import { version } from '~/package.json'

export default defineAppConfig({
  appVersion: version,
  siteName: 'KFV Portal Trainer',
  tenantId: '3ea079e3-7de4-47de-ab8f-cb174a7ec9a5',
  routing: {
    startPage: 'projects'
  },
  vendor: {
    vuelidate: {
      $lazy: true,
      $autoDirty: false
    },
    marked: { headerIds: false, mangle: false }
  },
  optimizeDeps: {
    include: ['esm-dep' > 'cjs-dep']
  },
  ui: {
    primary: 'customPrimary'
  }
})
